import React, { useState, useCallback, useEffect, useReducer } from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "@material-ui/core";
import Joi, { valid } from "joi";
import { Spinner } from "../../../../../../../Components";
import { MessageConfirmDialog } from "../../../../../../../SharedComponents";
import {
  GetParams,
  showError,
  showSuccess,
  bottomBoxComponentUpdate,
} from "../../../../../../../Helper";
import {
  GetPaymentFormAPI,
  UpdatePaymentFormAPI,
} from "../../../../../../../Services";
import { PaymentInformationComponent } from "./PaymentInformationComponent";

export const ContactProfilePaymentInformationComponent = ({
  parentTranslationPath,
  translationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [activeItem, setActiveItem] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [isLoadingForm, setIsLoadingForm] = useState(false);
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);

  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  const reducer2 = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);

  const [defaultState, setDefaultState] = useState({
    id: null,
    memberId: null,
    accountHolderName: null,
    accountTypeId: null,
    bankName: null,
    iban: null,
    bankBranchName: null,
    countryId: null,
    bankAccountNumber: null,
    currencyId: null,
    swiftCode: null,
  });

  const [defaultSelected, setDefaultSelected] = useState({
    accountType: null,
    country: null,
    currency: null,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [selected, setSelected] = useReducer(reducer, {
    ...defaultSelected,
  });
  const [state, setState] = useReducer(reducer2, {
    ...defaultState,
  });

  const schema = Joi.object({
    accountTypeId: Joi.number()
      .required()
      .messages({
        "any.required": t(`${translationPath}account-type-is-required`),
        "number.base": t(`${translationPath}account-type-is-required`),
      }),
    accountHolderName: Joi.string()
      .required()
      .messages({
        "any.required": t(`${translationPath}account-holder-name-is-required`),
        "string.base": t(`${translationPath}account-holder-name-is-required`),
      }),
    swiftCode: Joi.string()
      .required()
      .messages({
        "any.required": t(`${translationPath}swift-code-is-required`),
        "string.base": t(`${translationPath}swift-code-is-required`),
      }),
    iban: Joi.string()
      .required()
      .messages({
        "any.required": t(`${translationPath}iban-is-required`),
        "string.base": t(`${translationPath}iban-is-required`),
      }),
    currencyId: Joi.number()
      .required()
      .messages({
        "number.base": t(`${translationPath}currencyId-type-is-required`),
        "number.empty": t(`${translationPath}currencyId-type-is-required`),
        "number.required": t(`${translationPath}currencyId-type-is-required`),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(state);

  useEffect(() => {
    setContactId(+GetParams("id"));
  }, [GetParams("id")]);

  const onChangeHandler = (key, values, selectedObj, selectedValues) => {
    if (!selectedObj) {
      setState({ id: [key], value: values });
    } else {
      setState({ id: [key], value: values });
      setSelected({ id: [selectedObj], value: selectedValues });
    }
  };

  const saveHandler = async () => {
    setIsLoadingForm(true);
    setIsSubmitted(true);
    if (schema.error) {
      setIsLoadingForm(false);
      showError(t`${translationPath}please-fill-all-required-faileds`);

      return;
    }
    const res = await UpdatePaymentFormAPI(state);
    if (res?.StatusCode === 500) {
      showError(t`${translationPath}payment-information-update-failed`);
    } else {
      showSuccess(t`${translationPath}update-payment-information-successfully`);
      reloadHandler();
      setIsMissingInfoMSGOpen(false);
    }
    setIsLoadingForm(false);
  };

  const GetPaymentFormById = useCallback(async () => {
    setIsLoadingForm(true);
    let res = await GetPaymentFormAPI({ contactId });
    if (!(res && res.status && res.status !== 200)) {
      setState({ id: "edit", value: res });
      const newSelect = {
        accountType: res?.accountTypeId
          ? { id: res.accountTypeId, name: res?.accountTypeName }
          : null,
        country: res?.countryId
          ? { id: res.countryId, name: res?.countryName }
          : null,
        currency: res?.currencyId
          ? { id: res.currencyId, name: res?.currencyName }
          : null,
      };
      setSelected({ id: "edit", value: { ...newSelect } });
    } else {
      setState({ id: "edit", value: defaultState });
      setSelected({ id: "edit", value: defaultSelected });
    }
    setIsLoadingForm(false);
  }, [contactId]);

  useEffect(() => {
    if (contactId) GetPaymentFormById();
  }, [GetPaymentFormById, contactId]);

  const reloadHandler = async () => {
    GetPaymentFormById();
  };
  useEffect(() => {
    bottomBoxComponentUpdate(null);
  });

  return (
    <div className="associated-contacts-wrapper childs-wrapper">
      <Spinner isActive={isLoadingForm} isAbsolute />
      <div className="filter-sections-wrapper mb-2">
        <div className="filter-section-item">
          <span className="mt-2 mb-2 px-4 fz-14px d-flex">
            <span className="mdi mdi-information-outline c-danger px-2 mt-2" />
            <h5 style={{ "line-height": "22px" }}>
              {t`${translationPath}This-is-a-club-member-Are-you-sure-you-want-to-proceed-with-the-update`}
            </h5>
          </span>
        </div>
      </div>
      <div className="contact-units-wrapper  px-4">
        <PaymentInformationComponent
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onChangeHandler={onChangeHandler}
          state={state}
          selected={selected}
          isDisabled={false}
          setIsMissingInfoMSGOpen={setIsMissingInfoMSGOpen}
          GetPaymentFormById={GetPaymentFormById}
          schema={schema}
          isSubmitted={isSubmitted}
          isLoadingForm={isLoadingForm}
        />
      </div>
      {isMissingInfoMSGOpen && state?.id && (
        <MessageConfirmDialog
          isDialogOpen={isMissingInfoMSGOpen}
          theme="warning"
          content={{
            heading: t`${translationPath}update-payment-information`,
            body: t`${translationPath}This-is-a-club-member-Are-you-sure-you-want-to-proceed-with-the-update`,
          }}
          confirmButton={{
            label: t`${translationPath}confirm`,
            handler: () => saveHandler(),
          }}
          cancelButton={{
            label: t`${translationPath}discard`,
            handler: () => setIsMissingInfoMSGOpen(false),
          }}
          translationPath={translationPath}
          parentTranslationPath={parentTranslationPath}
        />
      )}
    </div>
  );
};
